import {doAjax} from 'surveylabJsAssets/common/_ajax';

export default function () {
    $(function () {
        // User comment function
        $('.sl-js-help-button').on('click', function () {
            $('#sl-js-help-modal').modal();
        });
        // See http://getbootstrap.com/javascript/#modals (section "Events")
        $('#sl-js-help-modal').on('shown.bs.modal', function () {
            let counter = {
                'pageID': $("input[name='hidden-page-id']").val(),
                'userSurveyID': $("input[name='hidden-user-survey-id']").val()
            };
            let countHelpUrl = $('#sl-js-count-help-url').val();
            doAjax({url: countHelpUrl, data: counter});
        });
    });
}